export default __webpack_public_path__ + "static/logo7_v1_final_optimised-0f8ebb94392b2bd5efe79b4839f1f35c.svg";